import $ from 'jquery';

const updateCartVariantTitles = () => {
  $('[data-cart-variant-title]').each((i, el) => {
    const $el = $(el);
    const content = $el.html();

    if (content === 'null') {
      $el.hide();
    } else {
      $el.show();
    }

    console.log('variant title:', $el.html());
  });
};

export default () => {
  $(document).on('cartDidUpdate, cartWillOpen', () => {

    updateCartVariantTitles();
  });
};
